import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, IconCheckmarkCircle, IconTrash, Modal, OptionInterface, Table, TablePagination, TablePreferences } from '@veneer/core';
import { useTranslation } from 'react-i18next';
import './../../assets/css/views/Sales/sales.css';
import { useNavigate } from 'react-router-dom';
import PointofSalesLogic, { columnsWidth } from './PointofSalesLogic';
import { IPosIn } from '../../models/input/agendaApi/IPosIn';

export default function POSManagementMain() {
    const [t] = useTranslation("global");
    const navigate = useNavigate();

    const { getPOSInformationList, loadingTable, setAviableDeleteModal, dataPOSInformationList,
        aviableDeleteModal, dataTODelete, deletePOS, currentPage, setCurrentPage, columns2 } = PointofSalesLogic();
    const [pageSize, setPageSize] = useState<number>(20);

    useEffect(() => {
        getPOSInformationList()
    }, [])

    const tablePreferences: TablePreferences = {
        width: columnsWidth,
    };

    const handleAddNewPointOfSale = () => {
        return (
            navigate('/createPOS')
        )
    };

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handlePageSizeChange = (
        event: React.MouseEvent<HTMLElement>,
        option: OptionInterface<number>
    ) => {
        setPageSize(option.value);
    };

    const paginationProps: TablePagination = {
        currentPage,
        onPageChange: handlePageChange,
        onPageSizeChange: handlePageSizeChange,
        pageSize,
        totalItems: dataPOSInformationList.length,
    };

    const handlerToDelete = () => {
        const params: IPosIn = {
            userID: 0,
            subRetailID: dataTODelete!.idSubRetail,
            pos: dataTODelete!.pointofSale,
            poS_ClassID: dataTODelete!.idClass,
            onLine: dataTODelete!.online ? 1 : 0,
            countryID: dataTODelete!.idCountry,
            stateID: dataTODelete!.idState,
            cityID: dataTODelete!.idCity,
            stratificationID: dataTODelete!.idStratification,
            longitude: dataTODelete!.longitude,
            latitude: dataTODelete!.latitude,
            active: dataTODelete!.active ? 0 : 1,
            poS_Code: dataTODelete!.posCode,
            cnpj: dataTODelete!.cnpj,
            address: ''
        }
        deletePOS(params)
    }

    const firstValueSlice = ((currentPage - 1) * pageSize)
    const secondValueSlice = ((currentPage - 1) * pageSize + pageSize)
    return (
        <div className='containeraddPoint'>
            {/* Botón para agregar nuevo punto de venta */}
            <div className="addPoint">
                <Button onClick={handleAddNewPointOfSale}>
                    {t('posManagement.addPOS')}
                </Button>
            </div>

            {/* Tabla de puntos de venta */}
            <Table
                behavior={{
                    type: 'singlePage',
                }}
                css={{
                    height: '78vh'
                }}
                columnResize
                loading={loadingTable}
                columns={columns2}
                data={dataPOSInformationList.slice(firstValueSlice, secondValueSlice)}
                loadingDataLength={5}
                preferences={tablePreferences}
                pagination={paginationProps}
                showFilters={true}
            />

            <div style={{ position: 'relative' }}>
                <Modal
                    className="modalBrandsConfirmDeletion"
                    align="center"
                    id="modalBrandsConfirmDeletion"
                    show={aviableDeleteModal}
                    footer={(
                        <ButtonGroup className="modalBrandsConfirmDeletionButtonGroup">
                            <Button onClick={handlerToDelete}>{t("header.confirm")}</Button>
                            <Button onClick={() => setAviableDeleteModal(false)} appearance="secondary">{t("header.cancel")}</Button>
                        </ButtonGroup>
                    )}
                    title={t("posManagement.activePOS")}
                >
                    {!dataTODelete?.active ? <IconCheckmarkCircle size={120} /> : <IconTrash size={120} />}
                    <br />
                    <b>{!dataTODelete?.active ? t("posManagement.msgActivePOS") : t('posManagement.msgDesactivePOS')}</b>
                </Modal>
            </div>
        </div>
    );
}
